import { ITableColumns } from "@monorepo-web/components-library";
import { IAviso } from "@monorepo-web/logic-extrato";
import { IObjDatas } from "@monorepo-web/utils";

export interface IPageData {
    ResCart: IResCartData | null,
    PerfHist: IPerfHistData | null
    PosCon: IPosConData | null
    RetornoAtivo: IPosConData | null
    CartExp: ICartExpData | null
    FluxoAtivo: IFluxoAtivosData | null
    EstatAvancada: IEstatAvancadaData | null
}

export const initialStatePageData: IPageData = {
    ResCart: null,
    PerfHist: null,
    PosCon: null,
    CartExp: null,
    RetornoAtivo: null,
    FluxoAtivo: null,
    EstatAvancada: null
};

export interface IResCartData {
    resumo: any,
    rowsRetorno: any,
    columnsRetorno: ITableColumns,
    rowsLiq: any,
    columnsLiq: ITableColumns,
    rowsClasse: any,
    columnsClasse: ITableColumns,
    rowsMovim: any,
    columnsMovim: ITableColumns,
    pieChartClassData: any,
    pieChartCustodianteData: any,
    obj_datas: IObjDatas,
    periodo: any
}

export interface IPerfHistData {
    rowsRetornos: any,
    dadosMesaMesAgrupados: any,
    columnsRetornos: ITableColumns,
    rowsMovim: any,
    columnsMovim: ITableColumns,
    data: any,
    dataEvol: any,
    assetsApi: string [] | null,
    barChartRend12Data: any,
    moneyPrefix: string | null,
}


export interface IPosConData {
    rowsDados: any,
    columnsDados: ITableColumns
    datas_dados_ativos_agrupados: any;
}

export interface ICartExpData {
    rowsDadosAgrupados: any,
    columnsDadosAgrupados: ITableColumns,
    aviso_carteira_explodida: IAviso,
    pieChartClasseData: any,
    obj_datas: IObjDatas
}

export interface IFluxoAtivosData {
    rowsFluxoAtivos: any,
    columnsFluxoAtivos: ITableColumns,
}

export interface IEstatAvancadaData {
    rowsInfos1: any,
    columnsInfos1: ITableColumns,
    rowsInfos2: any,
    columnsInfos2: ITableColumns,
    rowsRetornos: any,
    rowsVol: any,
    rowsSharpe: any,
    columnsDefault: ITableColumns,
    bench: any,
    benches: any,
}